/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Wed Feb 19 2025
 **/

import styled from "@emotion/styled";
import { css } from "@emotion/react";

import { Column } from "@/frameworks/designStuff/components";

/* Desktop */

export const RightFilePreviewContainer = styled(Column)`
	width: 100%;
	height: 100%;
	min-width: 400px;
	padding-top: 60px;
	background-color: ${({ theme }) => theme.colors.primary_70_100};
	scrollbar-color: ${({ theme }) => theme.colors.neutral_30_100} transparent;

	&::-webkit-scrollbar-track: {
		background: transparent;
	}
	&::webkit-scrollbar-thumb: {
		background-color: ${({ theme }) => theme.colors.neutral_30_100};
	}
`;

export const LeftFilePreviewContainer = styled(Column)`
	height: 100%;
	background-color: ${({ theme }) => theme.colors.primary_70_100};
	scrollbar-color: ${({ theme }) => theme.colors.neutral_30_100} transparent;

	&::-webkit-scrollbar-track: {
		background: transparent;
	}

	&::webkit-scrollbar-thumb: {
		background-color: ${({ theme }) => theme.colors.neutral_30_100};
	}
`;

export const RightFileWrap = styled(Column)`
	width: 100%;
	height: 100%;
	& > .react-transform-wrapper {
		height: 100%;
		width: 100%;
	}
`;

export const wrapListThumbnail = css`
	overflow: auto;
	width: 259px;
	margin-left: 16px;
	margin-top: 120px;
`;

export const wrapThumbnail = (currentPage: number, index: number, activeColor: string) => {
	return css`
		border: 6px solid ${currentPage === index ? activeColor : "transparent"};
		border-radius: 6px;
		cursor: pointer;
		img {
			width: 172px;
		}
	`;
};

/* Mobile */

export const FileViewerMobileThumbnailWrap = styled(Column)`
	position: absolute;
	z-index: 1;
	top: 60px;
	left: 0;
	width: 25%;
	height: calc(100% - 60px);
	padding: 24px 16px;
	overflow: auto;
	background-color: ${({ theme }) => theme.colors.neutral_blue_70_100};
	scrollbar-color: ${({ theme }) => theme.colors.neutral_30_100} transparent;

	&::-webkit-scrollbar-track: {
		background: transparent;
	}

	&::webkit-scrollbar-thumb: {
		background-color: ${({ theme }) => theme.colors.neutral_30_100};
	}
`;

export const wrapThumbnailMobile = (currentPage: number, index: number, activeColor: string) => {
	return css`
		border: 6px solid ${currentPage === index ? activeColor : "transparent"};
		border-radius: 6px;
		cursor: pointer;
		width: 100%;
		img {
			width: 100%;
		}
	`;
};

export const ThumbnaiButtonMobile = styled.div`
	position: absolute;
	top: 12px;
	left: 14px;
	z-index: 2;
`;

export const styleImageViewer = css`
	width: 100%;
	height: 100%;
	max-height: calc(100vh - 60px);
	object-fit: contain;
`;
